import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, getDocs } from "firebase/firestore";
import { useParams } from "react-router-dom";

interface UnCompleteOrderItem {
  id: string;
  code: string;
  point: number;
  price: string;
  productImage: string;
  productName: string;
  producttype: string;
  quantity: number;
  timestamp: any;
}

const UnCompleteUserOrders: React.FC = () => {
  const { userId } = useParams();
  const [items, setItems] = useState<UnCompleteOrderItem[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchUserOrders = async () => {
    if (!userId) return;

    setLoading(true);
    try {
      const ordersRef = collection(db, "Order", userId, "UnCompleteOrder");
      const snapshot = await getDocs(ordersRef);

      const fetchedItems: UnCompleteOrderItem[] = snapshot.docs.map((doc) => {
        const data = doc.data();
        return {
          id: doc.id,
          code: data.code || "",
          point: data.point || 0,
          price: data.price || "0",
          productImage: data.productImage || "",
          productName: data.productName || "",
          producttype: data.producttype || "",
          quantity: data.quantity || 0,
          timestamp: data.timestamp || null,
        };
      });

      setItems(fetchedItems);
    } catch (error) {
      console.error("Error fetching user uncomplete orders:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserOrders();
  }, [userId]);

  return (
    <div className="product-container">
      <h2 style={{ marginBottom: "20px" }}>تفاصيل الطلبات غير المكتملة</h2>

      {loading ? (
        <p>جاري تحميل البيانات...</p>
      ) : items.length === 0 ? (
        <p>لا توجد بيانات</p>
      ) : (
        <div className="table-container">
          <table className="product-table">
            <thead className="color-table">
              <tr>
                <th>#</th>
                <th>الصورة</th>
                <th>اسم المنتج</th>
                <th>الكود</th>
                <th>السعر</th>
                <th>الكمية</th>
                <th>النقاط</th>
                <th>النوع</th>
                <th>الوقت</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item, index) => (
                <tr key={item.id}>
                  <td>{index + 1}</td>
                  <td>
                    {item.productImage ? (
                      <img
                        src={item.productImage}
                        alt={item.productName}
                        style={{
                          width: "60px",
                          height: "60px",
                          objectFit: "cover",
                          borderRadius: "6px",
                        }}
                      />
                    ) : (
                      "لا توجد صورة"
                    )}
                  </td>
                  <td>{item.productName}</td>
                  <td>{item.code}</td>
                  <td>{item.price}</td>
                  <td>{item.quantity}</td>
                  <td>{item.point}</td>
                  <td>{item.producttype}</td>
                  <td>
                    {item.timestamp?.toDate
                      ? item.timestamp.toDate().toLocaleString("ar-IQ")
                      : "غير متوفر"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default UnCompleteUserOrders;